import { createContext } from "react";
import { Balance } from "../constants/constants";

const DataContext = createContext<{
  userTele: any;
  setUserTele: React.Dispatch<React.SetStateAction<any>>;
  wallet: any;
  setWallet: React.Dispatch<React.SetStateAction<any>>;
  balanceToken: Balance[] | null;
  setBalanceToken: React.Dispatch<React.SetStateAction<Balance[]>>;
  setButtonBackTele: (status: boolean, callback: () => void) => void;
  setIsShowLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setDescriptionLoading: React.Dispatch<React.SetStateAction<string>>;
  getBalanceToken: () => void;
} | null>(null);

export default DataContext;
